// Demografi grafikleri renkleri.
//
// Cinsiyet iki kategorik seridir (kimlik, büyüklük değil). Çift, dataviz
// referans paletinin 1. (mavi) ve 5. (magenta) slotlarından; validate_palette
// ile açık zeminde doğrulandı: CVD ΔE 12.4, normal görüş ΔE 26.6, ikisi de ≥3:1
// kontrast. Kimlik yalnız renge bırakılmaz — lejantta etiket + sayı her zaman yazılır.
export const GENDER_COLORS = {
  Kadın: "#d55181",
  Erkek: "#2a78d6",
};
